import { Controller } from '@hotwired/stimulus'

export default class ProjectImagesController extends Controller {
  static targets = ['image', 'imgContainer', 'carouselContainer', 'sectionContainer', 'carouselElement']

  connect() {
    this.filterImages();
  }

  filterImages() {
    this.imageTargets.forEach(image => {
      let category = image.dataset.category;
      let sectionCategory = image.closest('[data-project-images-target="sectionContainer"').dataset.category;

      if (sectionCategory === category) {
        image.closest('[data-project-images-target="imgContainer"]').classList.remove('d-none');
      } else {
        image.closest('[data-project-images-target="imgContainer"]').classList.add('d-none');
      }
    });
  }

  scrollToSection(event) {
    const sectionId = event.currentTarget.dataset.sectionValue;
    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;

    document.querySelector(sectionId).scrollIntoView({ behavior: isReduced ? 'instant' : 'smooth' });
  }

  // TODO(rebranding): improve keyboard navigation
  toggleCarousel(event) {
    const carouselController =
      this.application.getControllerForElementAndIdentifier(
        this.carouselElementTarget,
        'carousel-stimulus'
      );

    if (this.carouselContainerTarget.classList.contains('d-none')) {
      carouselController.customSlideTo(event.currentTarget.dataset.imgIndex)
      this.carouselContainerTarget.classList.remove('d-none');
      this.carouselContainerTarget.focus();
    } else {
      this.carouselContainerTarget.classList.add('d-none');
    }
    this.carouselContainerTarget.closest('.modal').classList.toggle('overflow-hidden');
  }
}
